import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { Button, Grid, Menu, TextField, Typography } from '@mui/material';
import * as React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { search, textInput, textInput2 } from "../../../assets/icons";
import { toASCII } from '../../../helpers/index';
import { useSelector } from 'react-redux';
import { getToastSelector } from '@redux/toast/selectors';
import { AppState } from '@configs/store/rootReducer';
import { useDispatch } from 'react-redux';
import { openToast } from '@redux/toast/actions';
import { addLanguageRequest } from '@redux/Language/actions';
export interface IModalAddLanguageProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  handleClose: () => void;
}

const schema = yup.object({
  name: yup.string().required("Vui lòng nhập tên ngôn ngữ"),
  id: yup.string().required("Vui lòng nhập mã. VD: vi, en, jp,..."),
});

export default function ModalAddLanguage (props: IModalAddLanguageProps) {
  // const toast = getToastSelector
  const toast = useSelector((state: AppState) => state.toOpen)
  const dispatch = useDispatch()
  const { anchorEl, open, handleClose } = props;
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    resetField,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const [language, setLanguage]= React.useState<String>("");
  const [langId, setLangId]= React.useState<String>("");
  const message = useSelector((state: AppState) => state.toTranslate.message)

  const onSubmit = async(data: any) => {
    if(langId !=="" && language !==""){
      dispatch(addLanguageRequest({body:{key:langId ,name:language}}))
    }
    handleClose()
  };
  
  const handleCloseModal = () => {
    handleClose()
    dispatch(openToast({
      severity:"error",
      text:"Close",
      open:true
    }))
  }

  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}
      sx={{ mt: 3, mr: 2 }}
    >
      <form id="my-form">
        <Grid
          container
          alignItems={"center"}
          sx={{ p: 2, width: '100%', marginTop: 2, maxWidth: '275px' }}
        >
          <Grid item lg={12} container alignItems={'center'} justifyContent={'center'}>
            <Typography variant='h6' component={'h2'} sx={{ fontWeight: '400' }}>Thêm ngôn ngữ</Typography>
          </Grid>
          <Grid item lg={12} container alignItems={'center'} wrap={'nowrap'} sx={{ mt: 3 }}>
            <img src={textInput} alt="" style={{width:"30px"}}/>
            <div style={{ width: "95%" }}>
              <Controller
                name="title"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    fullWidth
                    variant="standard"
                    label="Nhập ngôn ngữ"
                    color="info"
                    value={language ===""?value: language}
                    error={!!errors?.title}
                    // helperText={errors?.title?.message}
                    onChange={(e) => {
                      setValue("slug", toASCII(e.target.value));
                      onChange(setLanguage(e.target.value));
                    }}
                    sx={{ ml: 2, width: 'unset' }}
                  />
                )}
              />
            </div>
          </Grid>
          <Grid item lg={12} container alignItems={'center'} wrap={'nowrap'} sx={{ mt: 2 }} >
            <img src={textInput} alt="" style={{width:"30px"}}/>
            <div style={{ width: "95%" }}>
              <Controller
                name="title"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <TextField
                    fullWidth
                    variant="standard"
                    label="Nhập mã"
                    color="info"
                    value={langId ===""?value:langId}
                    error={!!errors?.title}
                    // helperText={errors?.title?.message}
                    onChange={(e) => {
                      setValue("slug", toASCII(e.target.value));
                      onChange(setLangId(e.target.value));
                    }}
                    sx={{ ml: 2, width: 'unset' }}
                  />
                )}
              />
            </div>
          </Grid>
          <Grid item lg={12} container alignItems={'center'} justifyContent={'flex-end'} wrap={'nowrap'} sx={{ mt: 5 }}>
            <Button variant='contained' color='secondary' sx={{ mr: 1 }} onClick={handleCloseModal}>Hủy</Button>
            <Button variant='contained' color='primary' onClick={onSubmit}>Lưu</Button>
          </Grid>
        </Grid>
      </form>
    </Menu>
  );
}
